/**
 * Common types for field formatters
 */

import type {TFunction} from 'i18next'

import type {FinalReviewItemValue} from '../../components/finalReview/finalReviewItem/FinalReviewItem.types'

/**
 * Result of formatting a field for final review
 */
export interface FieldFormatterResult {
  values: FinalReviewItemValue[]
  requiresApproval: boolean
  hasChanges: boolean
}

/**
 * Complete data for a final review item (field with metadata)
 */
export interface FinalReviewItemData {
  fieldId: string
  label: string
  values: FinalReviewItemValue[]
  requiresApproval: boolean
  hasChanges: boolean
}

/**
 * Grouped section of final review items
 */
export interface FinalReviewSection {
  sectionId: string
  sectionLabel: string
  items: FinalReviewItemData[]
}

/**
 * Context passed to all field formatters
 */
export interface FormatterContext {
  t: TFunction
  language: string
}

/**
 * Generic field formatter function signature
 */
export type FieldFormatter = (context: FormatterContext) => FieldFormatterResult
